import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M10.254 13a6 6 0 0 0-5.579 4.068l-.295.867c-.217.64.073 1.34.68 1.64a13.4 13.4 0 0 0 5.15 1.36A6.97 6.97 0 0 1 9 17c0-1.487.464-2.866 1.254-4M15 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 22a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-8a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 0 1 0-2h1v-1a1 1 0 0 1 1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgAddUserFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AddUserFilled_default = SvgAddUserFilled;

export { AddUserFilled_default as default };
